import React from "react";
import PropTypes from "prop-types";
import { OkButton } from "components/Buttons";
import BaseDialog, { severityIcons } from "./BaseDialog";

function AlertDialog({ open, title, message, severity, onClose, buttonText, children }) {
  return (
    <BaseDialog
      open={open}
      onClose={onClose}
      idPrefix="alert-dialog"
      icon={severityIcons[severity] || severityIcons.info}
      title={title}
      message={message}
      actions={
        <OkButton onClick={onClose} autoFocus>
          {buttonText}
        </OkButton>
      }
    >
      {children}
    </BaseDialog>
  );
}

AlertDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  severity: PropTypes.oneOf(["info", "success", "warning", "error"]),
  onClose: PropTypes.func.isRequired,
  buttonText: PropTypes.string,
  children: PropTypes.node,
};

AlertDialog.defaultProps = {
  severity: "info",
  buttonText: "Tamam",
  children: null,
};

export default AlertDialog;
